/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.2.0",
  "gitBuildTime": "2026-10-20T13:33:20.235Z",
  "gitBuildVersion": "2.2.0",
  "gitCommitId": "db7bc27",
  "gitCommitIdFull": "db7bc275ff99e5acf82f0c3b608795f0d71806cb",
  "gitCommitTime": "2026-10-20T13:30:35.000Z",
  "version": "2.2.0-2026-10-20T13:30:35.000Z-(db7bc27)"
};
